module.exports = __webpack_public_path__ + "img/liantong-banner.456a7405.png";